import { makeObservable, observable, action } from 'mobx';
import { ICodelistRow } from '../../swagger/gd/codelist';

class CodelistStore {
  cl: Record<string, ICodelistRow[]> = {};

  constructor() {
    makeObservable(this, {
      cl: observable,
      setCodelist: action
    });
  }

  setCodelist = (key: string, rows: ICodelistRow[]) => {
    this.cl[key] = rows;
  };

  getCodelist = <T extends ICodelistRow = ICodelistRow>(key: string): T[] => {
    return (this.cl[key] ?? []) as T[];
  };
}

const singleton = new CodelistStore();
export default singleton;
